import { echartSetOption } from '../echarts-utils';

const basicGaugeChartInit = () => {
  const { getColor, getData } = window.phoenix.utils;
  const $chartEl = document.querySelector('.echart-basic-gauge-chart-example');

  const tooltipFormatter = params => {
    return `
    <div>
        <h6 class="text-md text-subtle mb-0">
          <span class="fas fa-circle me-1" style='color:${params[0].color}'></span>
          ${params[0].name} : ${params[0].value}
        </h6>
    </div>
    `;
  };

  if ($chartEl) {
    const userOptions = getData($chartEl, 'echarts');
    const chart = window.echarts.init($chartEl);
    const getDefaultOptions = () => ({
      tooltip: {
        trigger: 'axis',
        padding: [7, 10],
        backgroundColor: getColor('background-color-subtle'),
        borderColor: getColor('border-color-base'),
        textStyle: { color: getColor('text-color-emphasis') },
        borderWidth: 1,
        formatter: params => tooltipFormatter(params),
        transitionDuration: 0,
        axisPointer: {
          type: 'none'
        }
      },
      radius: '100%',
      series: [
        {
          name: 'Pressure',
          type: 'gauge',
          splitLine: {
            lineStyle: {
              color: getColor('text-color-subtle')
            }
          },
          axisLabel: {
            color: getColor('text-color-subtle')
          },
          detail: {
            formatter: '{value}'
          },
          title: {
            color: getColor('text-color-subtle')
          },
          data: [
            {
              value: 50,
              name: 'SCORE',
              detail: {
                color: getColor('text-color-subtle')
              }
            }
          ]
        }
      ]
    });
    echartSetOption(chart, userOptions, getDefaultOptions);
  }
};

export default basicGaugeChartInit;
